import React, { useState, useContext, useEffect } from 'react'
import swal from 'sweetalert'
import VehiculosPage from '../../pages/LeadsPage/VehiculosPage/VehiculosPage'

import { permitsList, swalMessages } from '../../constants'
import { Context } from '../../context/Contex'

import { getVehiculos, postVehiculos,putVehiculos, deleteVehiculo } from '../../services/vehiculosService'
import { getUnidadNegocio } from '../../services/leadsunidadNegocioService'
import { getMarcas } from '../../services/leadMarcasService'

const searchArray = {
  linea: null,
  unidadNegocio: null,
  marca: null,
  estado: null
}

const initialForm = {
  linea: '',
  marca: '',
  nombre_unidad_negocio: '',
  estado: 0,
}
const initialControls = {
  marcasControl: [],
  unidadNegociosControl: [],
}

const CampanasContainer = () => {
  const [details, setDetails] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  const [form, setForm] = useState(initialForm)
  const [vehiculos, setVehiculos] = useState([])
  const [unidadNegocios, setUnidadNegocios] = useState([])
  const [marcas, setMarcas] = useState([])
  const [filterArray, setFilterArray] = useState([])
  const [openDetails, setOpenDetails] = useState(false)
  const [openAddForm, setOpenAddForm] = useState(false)
  const [controls, setControls] = useState(initialControls)
  const [campanas, setCampanas] = useState([])
  const { permisos } = useContext(Context)
  const permitValue = permisos[permitsList.LEADS_ADMIN]

  const fetchVehiculos = async () => {
    const { success, data } = await getVehiculos()
    if (success) {
      setVehiculos(data)
      setFilterArray(data);
    } else {
      console.log('error')
    }
  }

  const fetchUnidadNegocio = async () => {
    const { success, data } = await getUnidadNegocio()
    if (success) {
      setUnidadNegocios(data)
    } else {
      console.log('error')
    }
  }

  const fetchMarcas = async () => {
    const { success, data } = await getMarcas()
    if (success) {
      setMarcas(data)
    } else {
      console.log('error')
    }
  }

  const filterVehiculos = ({ vehiculo, param, value }) => {
    const empty = !value || value === '0';
    switch (param) {
      case 'marca': {
        return vehiculo[param].includes(value) || empty;
      }
      case 'estado': {
        const estado = value === 'SI' ? '1' : '0';
        return vehiculo[param] === estado || empty;
      }
      case 'unidadNegocio': {
        return vehiculo['nombre_unidad_negocio'].includes(value) || empty;
      }
      default: {
        const validVehiculo = String(vehiculo[param]) === value;
        return validVehiculo || empty;
      }
    }
  };


  /** metodo de los filtros */
  const handleChange = (filter, value) => {
    console.log(filter, value, 'filter')
    Object.assign(searchArray, { [filter]: value })
    const updatedLineas = Object.keys(searchArray).reduce(
      (reducedVehiculos, filterKey) => {
        reducedVehiculos = reducedVehiculos.filter((vehiculo) =>
          filterVehiculos({
            vehiculo,
            param: filterKey,
            value: searchArray[filterKey],
          }),
        )
        return reducedVehiculos
      },
      vehiculos,
    )
    setFilterArray(updatedLineas)
  }

  // peticiones API
  const handleSubmit = async (e) => {
    e.preventDefault()
    setOpenAddForm(false)
    if (isEdit) {
      const { success } = await putVehiculos({
        ...form,
      })
      if (success) {
        fetchVehiculos()
        swal(swalMessages.SUCCESSFUL_MESSAGE)
      } else {
        swal(swalMessages.GENERAL_ERROR)
      }
    } else {
      const { success } = await postVehiculos({
        ...form,
      })

      if (success) {
        fetchVehiculos()
        swal(swalMessages.SUCCESSFUL_MESSAGE)
      } else {
        swal(swalMessages.GENERAL_ERROR)
      }
    }
    setIsEdit(false)
    setForm(initialForm)
    setControls(initialControls)
    handleChange('vehiculos', '')
  }

  const handleDelete = async (rowData) => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        const response = deleteVehiculo(rowData.id)
        if (response) {
          const updated = vehiculos.filter(
            (vehiculo) => vehiculo.id !== rowData.id,
          )
          const updatedVehiculos = filterArray.filter(
            (vehiculo) => vehiculo.id !== rowData.id,
          )
          setFilterArray(updatedVehiculos)
          setCampanas(updated)
        } else {
          swal(swalMessages.GENERAL_ERROR)
        }
      }
    })
  }
  

  // Control INPUTS
  const onChangeInputs = (value, field) => {
    //console.log(value, field, 'value')
    switch (field) {
      case 'nombre_unidad_negocio':
        {
          setForm({ ...form, ['unidad_negocio_id']: value.value, ['nombre_unidad_negocio']: value.label})
          setControls({ ...controls, unidadNegociosControl: value.label })
        }
        break
      case 'marca':
        {
          setForm({ ...form, [field]: value.value })
          setControls({ ...controls, marcasControl: value.value })
        }
        break
      default:
        setForm({ ...form, [field]: value })
        break
    }
  }

  // open and Close modal
  const onOpenForm = (evento, data) => {
    if (evento === 'edit') {
      const rowSelected = vehiculos
        .filter((vehiculo) => vehiculo.id === data.id)
        .pop()

      setControls({
        ...controls,
        marca: rowSelected.marca,
        nombre_unidad_negocio: rowSelected.nombre_unidad_negocio,
      })
      setForm({
        ...rowSelected,
        marca: rowSelected.marca ,
        nombre_unidad_negocio: rowSelected.nombre_unidad_negocio,
      })
      setIsEdit(true)
    }
    setOpenAddForm(true)
  }

  const onCloseForm = () => {
    setIsEdit(false)
    setControls(initialControls)
    setOpenAddForm(false)
    setForm(initialForm)
    setOpenDetails(false)
  }

  const onOpenDetails = (rowData) => {
    setOpenDetails(true)
    setDetails(rowData)
  }

  useEffect(() => {
    // fetchMunicipios();
    // fetchDepartamentos();
    // fetchCampana();
    // fetchEstablecimiento();
    fetchUnidadNegocio()
    fetchVehiculos()
    fetchMarcas()
  }, [])

  return (
    <VehiculosPage
      form={form}
      isEdit={isEdit}
      details={details}
      controls={controls}
      vehiculos={filterArray}
      marcas={marcas}
      unidadNegocios={unidadNegocios}
      onOpenForm={onOpenForm}
      onCloseForm={onCloseForm}
      openAddForm={openAddForm}
      permitValue={permitValue}
      openDetails={openDetails}
      handleDelete={handleDelete}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      onOpenDetails={onOpenDetails}
      controlComponent={vehiculos}
      onChangeInputs={onChangeInputs}
    />
  )
}

export default CampanasContainer
